import { Config } from '@comall-backend-builder/core/lib/parser';
import { createElement } from 'react';
import moment from 'moment';

import './live-room.less';

let LIVE_ROOM_PROPERTIES = {
    name: {
        type: 'string',
        displayName: '直播间名称',
        rules: [
            {
                required: true,
                message: '直播间名称不能为空',
            },
        ],
    },
    roomid: {
        type: 'number.integer',
        displayName: '直播间ID',
    },
    recommend: {
        type: 'string.options.select',
        displayName: '首页推介',
        options: [
            {
                id: 'RECOMMEND',
                name: '已设为推荐',
            },
        ],
    },
    dateTimeRange: {
        type: 'object.dateTimeRange',
        displayName: '直播时间',
        rules: [
            {
                required: true,
                message: '直播计划时间不能为空',
            },
        ],
    },
    anchorName: {
        type: 'string',
        displayName: '主播昵称',
        rules: [
            {
                required: true,
                message: '主播昵称不能为空',
            },
        ],
    },
    anchorWechat: {
        type: 'string',
        displayName: '主播微信号',
        rules: [
            {
                required: true,
                message: '主播微信号不能为空',
            },
        ],
    },
    liveStatus: {
        type: 'string.options.select',
        displayName: '直播间状态',
        options: [
            {
                id: '101',
                name: '直播中',
            },
            {
                id: '102',
                name: '未开始',
            },
            {
                id: '103',
                name: '已结束',
            },
            {
                id: '104',
                name: '禁播',
            },
            {
                id: '105',
                name: '暂停中',
            },
            {
                id: '106',
                name: '异常',
            },
            {
                id: '107',
                name: '已过期',
            },
        ],
    },
    type: {
        type: 'string.options.radio',
        displayName: '直播间类型',
        options: [
            {
                id: '0',
                name: '手机直播',
            },
            {
                id: '1',
                name: '推流',
            },
        ],
        rules: [
            {
                required: true,
            },
        ],
    },
    screenType: {
        type: 'string.options.radio',
        displayName: '屏幕',
        options: [
            {
                id: '0',
                name: '竖屏',
            },
            {
                id: '1',
                name: '横屏',
            },
        ],
        rules: [
            {
                required: true,
            },
        ],
    },
    closeLike: {
        type: 'string.options.radio',
        displayName: '是否关闭点赞',
        options: [
            {
                id: '0',
                name: '开启',
            },
            {
                id: '1',
                name: '关闭',
            },
        ],
        rules: [
            {
                required: true,
            },
        ],
    },
    closeGoods: {
        type: 'string.options.radio',
        displayName: '是否关闭货架',
        options: [
            {
                id: '0',
                name: '开启',
            },
            {
                id: '1',
                name: '关闭',
            },
        ],
        rules: [
            {
                required: true,
            },
        ],
    },
    closeComment: {
        type: 'string.options.radio',
        displayName: '是否关闭评论',
        options: [
            {
                id: '0',
                name: '开启',
            },
            {
                id: '1',
                name: '关闭',
            },
        ],
        rules: [
            {
                required: true,
            },
        ],
    },
    coverImg: {
        type: 'string.image.picker',
        displayName: '背景图',
        rules: [
            {
                required: true,
                message: '背景图不能为空',
            },
        ],
    },
    shareImg: {
        type: 'string.image.picker',
        displayName: '分享图',
        rules: [
            {
                required: true,
                message: '分享图不能为空',
            },
        ],
    },
    showStatus: {
        type: 'string.options.select',
        displayName: '是否显示',
        options: [
            {
                id: 'DISPLAY',
                name: '是',
            },
            {
                id: 'HIDE',
                name: '否',
            },
        ],
    },
    sort: {
        type: 'string',
        displayName: '顺序',
        controlConfig: {
            placeholder: '顺序',
        },
    },
};

export let config: Config = {
    entities: {
        // 直播间
        LiveRoom: {
            apiPath: '/loader/live-room-list',
            properties: LIVE_ROOM_PROPERTIES,
            filters: {
                showStatus: {
                    type: 'string.options.select',
                    displayName: '是否显示',
                    options: [
                        {
                            id: 'DISPLAY',
                            name: '是',
                        },
                        {
                            id: 'HIDE',
                            name: '否',
                        },
                    ],
                },
                liveStatus: {
                    type: 'string.options.select',
                    displayName: '直播间状态',
                    options: [
                        {
                            id: '101',
                            name: '直播中',
                        },
                        {
                            id: '102',
                            name: '未开始',
                        },
                        {
                            id: '103',
                            name: '已结束',
                        },
                    ],
                },
            },
        },

        // 直播间详情
        LiveRoomDetail: {
            apiPath: '/loader/live-room-detail',
            properties: LIVE_ROOM_PROPERTIES,
        },

        // 直播间商品
        LiveRoomProducts: {
            apiPath: '/loader/live-room-products',
            properties: {
                id: {
                    type: 'number.integer',
                    displayName: '序号',
                },
                name: {
                    type: 'string',
                    displayName: '商品名称',
                },
                coverImg: {
                    type: 'string.image.text',
                    displayName: '商品图片',
                },
                price: {
                    type: 'string',
                    displayName: '价格',
                },
                url: {
                    type: 'string',
                    displayName: '商品链接',
                },
            },
        },
    },
    components: {
        LiveRoomsPage: {
            component: 'Viewport',
        },

        LiveRoomsView: {
            component: 'Card',
            entity: 'LiveRoom',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    // {
                    //     component: 'LiveRoomsBtns',
                    // },
                    {
                        component: 'LiveRoomFilter',
                    },
                    {
                        component: 'liveRoomTable',
                    },
                ],
            },
        },

        LiveRoomFilter: {
            component: 'FilterFormPlus',
            direction: 'horizontal',
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'showStatus',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'liveStatus',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },

        LiveRoomsBtns: {
            component: 'FlexLayout',
            direction: 'horizontal',
            style: {
                marginBottom: 16,
            },
            align: 'start',
            items: [
                {
                    component: 'Button',
                    type: 'primary',
                    text: '创建直播间',
                    route: '/live-room/add',
                    style: {
                        flexGrow: 0,
                    },
                },
            ],
        },

        AddLiveRoom: {
            component: 'Card',
            entity: 'LiveRoom',
            content: {
                component: 'AddLiveRoomForm',
            },
        },

        AddLiveRoomForm: {
            component: 'CreateForm',
            entity: 'LiveRoom',
            direction: 'vertical',
            submit: { text: '创建直播间' },
            className: 'live-room-create-form',
            submitSuccessBehavior: {
                route: '/live-room',
            },
            footer: {
                items: [
                    {
                        text: '取消',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                        style: { marginLeft: 16 },
                    },
                ],
            },
            fields: [
                {
                    property: 'name',
                    label: createElement(
                        'span',
                        { className: 'live-room-label live-room-name' },
                        '直播间名称'
                    ),
                    controlConfig: {
                        style: {
                            width: 400,
                        },
                    },
                },
                {
                    property: 'dateTimeRange',
                    label: createElement(
                        'span',
                        { className: 'live-room-label live-room-time' },
                        '直播计划时间'
                    ),
                    controlConfig: {
                        range: {
                            start: moment(new Date()),
                        },
                        style: {
                            width: 400,
                        },
                    },
                },
                {
                    property: 'anchorName',
                    label: createElement(
                        'span',
                        { className: 'live-room-label live-room-anchor-name' },
                        '主播昵称'
                    ),
                    controlConfig: {
                        style: {
                            width: 400,
                        },
                    },
                },
                {
                    property: 'anchorWechat',
                    label: createElement(
                        'span',
                        { className: 'live-room-label live-room-anchor-wechat' },
                        '主播微信号'
                    ),
                    controlConfig: {
                        style: {
                            width: 400,
                        },
                    },
                },
                {
                    property: 'type',
                },
                {
                    property: 'screenType',
                },
                {
                    property: 'closeLike',
                },
                {
                    property: 'closeGoods',
                },
                {
                    property: 'closeComment',
                },
                {
                    property: 'coverImg',
                    label: createElement(
                        'span',
                        { className: 'live-room-label live-room-cover-img' },
                        '背景图'
                    ),
                    controlConfig: {
                        maxCount: 1,
                        multiple: false,
                        fileName: 'fileName',
                        uploadUrl: `${ENV.API_ROOT}/images`,
                        mode: 'picture-card',
                        maxSize: 2 * 1024,
                        uploadLimitSizeErrorMessage: '图片{{file.name}}超出限制，最大上传 2M 图片',
                    },
                },
                {
                    property: 'shareImg',
                    label: createElement(
                        'span',
                        { className: 'live-room-label live-room-share-img' },
                        '分享图'
                    ),
                    controlConfig: {
                        maxCount: 1,
                        multiple: false,
                        fileName: 'fileName',
                        uploadUrl: `${ENV.API_ROOT}/images`,
                        mode: 'picture-card',
                        maxSize: 1 * 1024,
                        uploadLimitSizeErrorMessage: '图片{{file.name}}超出限制，最大上传 1M 图片',
                    },
                },
            ],
        },

        LiveRoomInfoView: {
            component: 'Card',
            content: {
                component: 'LiveRoomInfo',
            },
        },

        LiveRoomDetail: {
            entity: 'LiveRoomDetail',
            loaderType: 'get',
            component: 'Detail',
            direction: 'vertical',
            footer: {
                items: [
                    {
                        text: '返回',
                        htmlType: 'button',
                        type: 'primary',
                        route: 'goBack',
                        style: {
                            marginTop: 16,
                        },
                    },
                ],
            },
            fields: [
                {
                    property: 'roomid',
                    label: '房间ID',
                },
                {
                    property: 'liveStatus',
                    label: '直播状态',
                },
                {
                    property: 'name',
                },
                {
                    property: 'dateTimeRange',
                },
                {
                    property: 'anchorName',
                },
                {
                    property: 'coverImg',
                    displayConfig: {
                        style: {
                            width: 104,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'shareImg',
                    displayConfig: {
                        style: {
                            width: 104,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
            ],
        },

        LiveRoomProducts: {
            entity: 'LiveRoomProducts',
            component: 'DataTable',
            loadFirstPage: true,
            scroll: {
                x: true,
            },
            columns: [
                {
                    property: 'id',
                },
                {
                    property: 'coverImg',
                    width: 100,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'name',
                },
                {
                    property: 'price',
                },
                {
                    property: 'url',
                },
            ],
        },

        LiveRoomAddProductPage: {
            component: 'FlexLayout',
            entity: 'LiveProduct',
            direction: 'vertical',
            align: 'justify',
            items: [
                {
                    component: 'LiveRoomAddProductFilter',
                },
                {
                    component: 'LiveRoomAddProduct',
                },
            ],
        },

        LiveRoomAddProductFilter: {
            component: 'FilterFormPlus',
            direction: 'inline',
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'skuList',
                    controlConfig: {
                        placeholder: '一次最多查询50个SKU，SKU间以空格分隔',
                        style: { width: 500 },
                    },
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '搜索',
            },
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/live-room',
                    breadcrumbName: '直播管理',
                    component: 'LiveRoomsPage',
                    childRoutes: [
                        {
                            path: '/add',
                            component: 'AddLiveRoom',
                            breadcrumbName: '创建直播间',
                        },
                        {
                            path: '/info/:roomid/:activeTab',
                            component: 'LiveRoomInfoView',
                            breadcrumbName: '查看直播间',
                        },
                        {
                            path: '/',
                            component: 'LiveRoomsView',
                            breadcrumbName: '直播间管理',
                        },
                    ],
                },
            ],
        },
    ],
};
